import find from 'lodash/find'
import { Colleague } from 'store/user/types'
import { Task } from 'store/tasks/types'

export const getAssigneeData = (assignees: Colleague[], tasks: Task[]) =>
  tasks
    .filter((task) => find(assignees, { userKey: task.assigneeKey }))
    .filter((task) => task)
    .map((task) => ({ task, assignee: find(assignees, { userKey: task.assigneeKey }) }))
